import {
	type IAccountBuyer,
	type IOfferDropDown,
	ERoleAccess
} from '../../types'
import dt from 'dayjs'
import { Access } from '../../lib'
import { getAccountIsFiredBadge } from '../account'
import { TFunction } from 'react-i18next'

export const accountOptionValue = (_: IAccountBuyer) => {
	return `${_.id}`
}

export const accountOptionLabel = (_: IAccountBuyer, t: TFunction) => {
	const accountIsFired = _?.isFired
	const accountIsFiredLabel = accountIsFired ? ` (${getAccountIsFiredBadge(accountIsFired, t, true)})` : ''

	return `[id: ${_.id}] ${_.auth.login ?? _.email}${accountIsFiredLabel}`
}

export const accountFormatOptionLabel = (_: IAccountBuyer, t: TFunction) => {
	const accountIsFired = _?.isFired

	return <>
		[<strong>id: {_.id}</strong>]
		&nbsp;
		{_.auth.login ?? _.email}
		{!!accountIsFired ? getAccountIsFiredBadge(accountIsFired, t) : null}
	</>
}

export const offerOptionValue = (_: IOfferDropDown) => {
	return `${_.id}`
}

export const offerOptionLabel = (_: IOfferDropDown) => {
	return `[id: ${_.id}] ${_.name}`
}

export const offerFormatOptionLabel = (_: IOfferDropDown) => {
	return <>
		[<strong>id: {_.id}</strong>]
		&nbsp;
		{_.name}
	</>
}

export const offerSpendConditions = (
	at: Date | dt.Dayjs,
	$access: Access
) => {
	const today = dt.utc(new Date()).startOf('day')
	const threeDaysBeforeToday = dt.utc(today).subtract(3, 'day')
	const hasOfferSpendAnyDay = $access.$(ERoleAccess.OfferSpendAnyDay)
	const isBetweenAvailableRange = dt(at).isBetween(threeDaysBeforeToday, today, 'day', '[]')
	const disabled = !hasOfferSpendAnyDay && !isBetweenAvailableRange

	return {
		today,
		threeDaysBeforeToday,
		hasOfferSpendAnyDay,
		isBetweenAvailableRange,
		disabled
	}
}
